
import Badge from "../Badge.vue";
import Section from "../Section.vue";
import { getProvinces, getProvinceWithCode } from "../../utils/staticData";
import { vietnameseTextToSlug } from "../../utils/common";

export default {
  components: {
    Section,
    Badge,
  },
  data() {
    return {
      BASE_URL_STATIC: this.$config.BASE_URL_STATIC,
      isServer: true,
      baseImageURL: this.$config.BASE_URL_RESOURCE,
      defaultFilter: [
        { value: "", label: "Toàn quốc" },
        { value: "01", label: "Hà Nội" },
        { value: "79", label: "TP. Hồ Chí Minh" },
        { value: "48", label: "Đà Nẵng" },
        { value: "92", label: "Cần Thơ" },
      ],
      selectedFilter: "",
      prevFilter: "",
      provinces: getProvinces("array"),
    };
  },
  props: {
    filter: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    readMore: {
      type: Boolean,
      default: true,
    },
    linkTo: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: "",
    },
    titleStyle: {
      type: String,
      default: "",
    },
    listEvent: {
      type: Array,
      default: () => [],
    },
  },
  mounted() {
    this.isServer = false;
  },
  methods: {
    handleFilterChange(value) {
      if (!this.filter) return;
      this.prevFilter = this.selectedFilter;
      this.selectedFilter = value;
      this.$emit("eventFilterChange", getProvinceWithCode(value));
    },
    getPath(title, id) {
      return vietnameseTextToSlug(title, id);
    },
  },
};
